import { Next } from '@wix/funnel-builder-lizard'

import { PageLogger } from '../../../../../bi/mfi'
import { onboardingAnswer } from '../../../../../bi/onboarding'
import { createMetadataFromBusinessTerm } from '../../../../../category/categoryInMetadata'
import { Save } from '../../../../../context/StorageContext/StorageContext'
import { extractNameSuggestions } from '../../WixMobileCategoryNoSuggestions/extractNameSuggestions'
import { SearchStateCategory } from '../types'

interface GoNextParams {
  category?: SearchStateCategory
  searchValue: string
  questionKey: string
  pageLogger: PageLogger
  language: string
  next: Next
  save: Save
  experiments: Record<string, string>
}

export const goNext = ({
  category,
  pageLogger,
  questionKey,
  searchValue,
  language,
  next,
  save,
  experiments,
}: GoNextParams) => {
  if (!category) {
    return
  }

  const { businessTerm = {}, businessSegmentId, index } = category
  const { displayName } = businessTerm

  const metadata = createMetadataFromBusinessTerm(businessTerm, businessSegmentId)
  const { segment, industryId, structureId } = metadata

  void pageLogger.answerCategory({ businessTerm, segment, businessSegmentId })
  void pageLogger.answer({ answer: businessTerm, position: index + 1, answerType: 'dropdown', freeText: searchValue })
  void onboardingAnswer({
    contentLanguage: language,
    navButton: 'next',
    text: searchValue,
    // for compatibility
    suggestList: 'unknown',
    name: displayName || '',
    selectedIndustryId: industryId || '',
    selectedStructureId: structureId || '',
  })

  const answerValues = displayName ? [displayName] : []
  const answers = { [questionKey]: { values: answerValues } }

  void extractNameSuggestions(searchValue).then(nameSuggestions => save({ nameSuggestions }))

  save({
    category: {
      ...category,
      search: searchValue,

      // for compatibility
      searchSource: 'unknown',
    },
  })
  next(answers, metadata)
}
